import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IEmailColumn extends ITableColumn {
  Settings: null
}

export interface IEmailCell extends ICell {
  settings: null
}

/**
 * @todo make sure wether we should parsed invalid email or not
 */
export class EmailCell implements IEmailCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    if (this.value === null || this.value === undefined || typeof this.value !== 'string') {
      return ''
    }
    return this.value.toString()
  }

  toCell<T extends Cell>(newValue: T) {
    if (!newValue || typeof newValue !== 'string') {
      this.value = ''
      return this
    }

    this.value = newValue
    return this
  }
}
